<div
  class="complete-profile-dialog-content"
  *ngIf="{
    isVolunteer: isVolunteer$ | async,
    selectedProfile: selectedProfile$ | async
  } as obs"
>
  <div class="flex-col">
    <div class="title-container">
      <h2 translate="ACCOUNT.COMPLETE_ACCOUNT_DIALOG.HEADER"></h2>
      <p class="complete-account-subheader">
        <span
          *ngIf="obs.isVolunteer"
          translate="ACCOUNT.COMPLETE_ACCOUNT_DIALOG.SUB_HEADER_VOLUNTEER"
          [translateParams]="{ guest: obs.selectedProfile | gbDisplayName }"
        >
        </span>
        <span *ngIf="!obs.isVolunteer" translate="ACCOUNT.COMPLETE_ACCOUNT_DIALOG.SUB_HEADER"></span>
      </p>
    </div>
    <gb-account-details-form
      class="complete-account-form"
      [config]="getFormConfig(obs.selectedProfile)"
      [dialog]="true"
      [shouldRedirect]="false"
      (cancel)="closeDialog()"
      (skip)="closeDialog()"
    >
    </gb-account-details-form>
  </div>
</div>
